export const type = 'alert.deliveryOrder';
